import React, { useState } from 'react'
import classNames from 'classnames'
import { useSubscriptionPolicy } from 'pobble-components/dist/subscriptions'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { CreateSlideModal } from '../../modals/create-slide/create-slide'

const NewSlideButton = ({ classes }) => {
  const editSp = useSubscriptionPolicy(
    sp => sp.lesson_planning.edit_presentation
  )

  const [modalOpened, setModalOpened] = useState(false)

  return (
    <>
      <Button
        wide
        tall
        secondary
        icon={<FontAwesomeIcon icon={faPlusCircle} />}
        className={classNames('metrics__add-new-slide')}
        action={
          editSp.restricted ? editSp.showDialog : () => setModalOpened(true)
        }>
        Add slide
      </Button>
      <CreateSlideModal
        isOpen={modalOpened}
        requestClose={() => setModalOpened(false)}
      />
    </>
  )
}

export default NewSlideButton
